const MIN_POLYGON_POINTS = 3;
const PATH_CHANGE_EVENTS = ['set_at', 'insert_at', 'remove_at'];

export type PolygonPointTarget = {
	polygon: google.maps.Polygon;
	vertex: number;
};

export type DeletedPolygonPoint = PolygonPointTarget & {
	position: google.maps.LatLng;
};

export const canDeletePolygonPoint = (polygon: google.maps.Polygon) =>
	polygon.getPath().getLength() > MIN_POLYGON_POINTS;

export function deletePolygonPoint({ polygon, vertex }: PolygonPointTarget): DeletedPolygonPoint | null {
	if (!canDeletePolygonPoint(polygon)) {
		return null;
	}

	return { polygon, vertex, position: polygon.getPath().removeAt(vertex) };
}

export function restorePolygonPoint({ polygon, vertex, position }: DeletedPolygonPoint) {
	polygon.getPath().insertAt(vertex, position);
}

// a point is held by its index, so any edit to the path makes it stale
export function listenToPathChanges(polygon: google.maps.Polygon, onChange: () => void) {
	const listeners = PATH_CHANGE_EVENTS.map(eventName =>
		google.maps.event.addListener(polygon.getPath(), eventName, onChange)
	);

	return () => listeners.forEach(listener => listener.remove());
}

export function attachPolygonPointMenu(
	polygon: google.maps.Polygon,
	onOpen: (target: PolygonPointTarget) => void
): google.maps.MapsEventListener {
	// `contextmenu`, not `rightclick` too: both fire on one right-click and the menu would open twice
	return polygon.addListener('contextmenu', (event: google.maps.PolyMouseEvent) => {
		if (event.vertex === undefined || !polygon.getEditable()) {
			return;
		}

		event.domEvent?.preventDefault();
		onOpen({ polygon, vertex: event.vertex });
	});
}
